import { Injectable, inject } from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {Dienst, DienstDto} from './dienst';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {Diensten} from './diensten';

@Injectable({
  providedIn: 'root'
})
export class DienstService {
  private http = inject(HttpClient);

  private diensten$: Subject<Diensten> = new ReplaySubject<Diensten>(1);

  constructor() {
    this.http
      .get<Array<DienstDto>>(`${environment.apiUrl}/diensten`)
      .pipe(
        map(dtos => dtos.map(dto => Dienst.deserialize(dto))),
        map(diensten => Diensten.of(diensten)),
      )
      .subscribe(diensten => this.diensten$.next(diensten));
  }

  getDiensten$(): Observable<Diensten> {
    return this.diensten$.asObservable();
  }
}
